import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "title font-size-24 mb-8 flex items-center" }
const _hoisted_2 = { class: "mb-8" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "text-grey-666" }
const _hoisted_8 = { class: "mb-4 font-size-14 font-bold" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "mb-2" }
const _hoisted_11 = { class: "mb-4 font-size-14 font-bold" }
const _hoisted_12 = { class: "bg-color-f8 px-6 pt-4 max-h-100 overflow-auto" }
const _hoisted_13 = { class: "mb-4 font-size-18 flex items-center" }
const _hoisted_14 = { class: "mb-4 text-grey-666" }
const _hoisted_15 = { class: "mr-2" }
const _hoisted_16 = { class: "mr-2" }
const _hoisted_17 = { class: "flex justify-end" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-close text-2xl mr-2" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-upload text-2xl mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerIcon = _resolveComponent("SpinnerIcon")
  const _component_WarningIcon = _resolveComponent("WarningIcon")
  const _component_Button = _resolveComponent("Button")
  const _component_Popup = _resolveComponent("Popup")

  return (_openBlock(), _createBlock(_component_Popup, {
    modelValue: _ctx.isShow,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShow = $event)),
    classes: "cus-popup",
    width: "720px"
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, _toDisplayString(_ctx.t('confirmationOfCapturedData')), 1),
      _createVNode("div", _hoisted_2, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_SpinnerIcon, { key: 0 }))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_4, [
              (
            _ctx.importShiftPlanDraftDetail.total_errors === 0 ||
            !_ctx.importShiftPlanDraftDetail.total_errors
          )
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    _createVNode("div", _hoisted_6, [
                      _createVNode("div", _hoisted_7, _toDisplayString(_ctx.t('allLines')) + ": " + _toDisplayString(_ctx.importShiftPlanDraftDetail.total_records), 1)
                    ]),
                    _createVNode("div", _hoisted_8, _toDisplayString(_ctx.file.name), 1)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_9, [
                    _createVNode("div", null, _toDisplayString(_ctx.t('thisCSVFileContainsAnError')), 1),
                    _createVNode("div", _hoisted_10, _toDisplayString(_ctx.t('ifYouWantToImportOnlyValidRows')), 1),
                    _createVNode("div", _hoisted_11, _toDisplayString(_ctx.file.name), 1),
                    _createVNode("div", _hoisted_12, [
                      _createVNode("div", _hoisted_13, [
                        _createVNode(_component_WarningIcon, { class: "mr-2 w-6" }),
                        _createTextVNode(_toDisplayString(_ctx.t('errorContents')), 1)
                      ]),
                      _createVNode("div", _hoisted_14, [
                        _createVNode("span", _hoisted_15, _toDisplayString(_ctx.t('allLines')) + ": " + _toDisplayString(_ctx.importShiftPlanDraftDetail.total_records), 1),
                        _createVNode("span", _hoisted_16, _toDisplayString(_ctx.t('validLines')) + ": " + _toDisplayString(_ctx.importShiftPlanDraftDetail.total_success), 1),
                        _createVNode("span", null, _toDisplayString(_ctx.t('inValidLines')) + ": " + _toDisplayString(_ctx.importShiftPlanDraftDetail.total_errors), 1)
                      ]),
                      _createVNode("div", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.importShiftPlanDraftDetail.error_content, (item) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "mb-4 font-size-14",
                            key: JSON.stringify(item)
                          }, _toDisplayString(item[0]), 1))
                        }), 128))
                      ])
                    ])
                  ]))
            ]))
      ]),
      _createVNode("div", _hoisted_17, [
        _createVNode(_component_Button, {
          variant: "outline-primary",
          class: "mr-4",
          onClick: _ctx.closePopup,
          disabled: _ctx.loading
        }, {
          default: _withCtx(() => [
            _hoisted_18,
            _createTextVNode(" " + _toDisplayString(_ctx.t('cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"]),
        _createVNode(_component_Button, {
          onClick: _ctx.onSubmit,
          disabled: _ctx.loading
        }, {
          default: _withCtx(() => [
            _hoisted_19,
            _createTextVNode(" " + _toDisplayString(_ctx.t('takeIn')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}